
/**
 * Utility functions for Level 3 scoring components
 */
import { getFormattedPoint as importedGetFormattedPoint } from '@/utils/level3/points';

// Current level detection
export const getCurrentLevel = (): 1 | 2 | 3 => {
  const pathname = window.location.pathname;
  if (pathname.includes('level1')) return 1;
  if (pathname.includes('level2')) return 2;
  return 3; // Default to level 3
};

// Test types detection
export const isSpecialPuttsTest = (testId: string | null): boolean => {
  if (!testId) return false;
  return testId.startsWith('putts-') && testId !== 'putts-plat';
};

export const isPuttingTest = (testId: string | null): boolean => {
  if (!testId) return false;
  return testId.startsWith('putts-');
};

export const isChippingTest = (testId: string | null): boolean => {
  if (!testId) return false;
  console.log("isChippingTest called with:", testId);
  return testId.startsWith('chipping-');
};

export const isWedgingTest = (testId: string | null): boolean => {
  if (!testId) return false;
  return testId.startsWith('wedging-');
};

export const isBunkerTest = (testId: string | null): boolean => {
  if (!testId) return false;
  return testId.startsWith('bunker-');
};

export const isIronTest = (testId: string | null): boolean => {
  if (!testId) return false;
  return testId.startsWith('iron-') && testId !== 'iron-green-attack' && testId !== 'iron-green-attack-100';
};

export const isGreenAttack2ZoneTest = (testId: string | null): boolean => {
  if (!testId) return false;
  return testId === 'iron-green-attack-100';
};

export const isGreenAttackTest = (testId: string | null): boolean => {
  if (!testId) return false;
  return testId === 'iron-green-attack' || testId === 'iron-green-attack-100';
};

export const isFairwayWoodTest = (testId: string | null): boolean => {
  if (!testId) return false;
  return testId.startsWith('fairwayWood-');
};

export const isDriverTest = (testId: string | null): boolean => {
  if (!testId) return false;
  return testId.startsWith('driver-');
};

// Re-export the imported function
export const getFormattedPoint = importedGetFormattedPoint;

